import script from "./index.vue?vue&type=script&setup=true&lang=js"
export * from "./index.vue?vue&type=script&setup=true&lang=js"

import "./index.vue?vue&type=style&index=0&id=3e73efc2&lang=scss&scoped=true"

import exportComponent from "D:\\work\\依申请公开平台\\前台\\apply-to-the-front-desk\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-3e73efc2"]])

export default __exports__